import { Trans } from 'react-i18next';

import { AppointmentCancellationDetails } from '@dreryk/egabinet-appointment-frontend-api';

import { dateFormatter, hourMinuteFormatter } from '@dreryk/react-common';
import { CancelAppointmentIcon } from '@dreryk/react-components';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { calendarTranslationKeys } from '../../../../../../translations';

import { useGetCancellationBy } from './AppointmentCancellationInfoItem.hooks';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

type AppointmentCancellationInfoItemProps = Readonly<{ cancellationDetails: AppointmentCancellationDetails }>;

export const AppointmentCancellationInfoItem = (props: AppointmentCancellationInfoItemProps): JSX.Element => {
   const description = useGetCancellationBy(props.cancellationDetails);
   const cancellationDate = dateFormatter(props.cancellationDetails.cancellationDate);
   const cancellationTime = hourMinuteFormatter(props.cancellationDetails.cancellationDate);

   return (
      <AppointmentDetailsInfoItem
         testId={'cancellationDetails'}
         content={
            <Trans
               i18nKey={t.cancellationAt}
               values={{ cancellationDate: cancellationDate, cancellationTime: cancellationTime }}
            />
         }
         description={description}
         icon={<CancelAppointmentIcon />}
      />
   );
};
